import {
  AIDeepInsights,
  AIGoalsReport,
  UserGoals
} from '@cpd-app/core-module/models';

export const goalFeatureKey = 'goal';

export interface GoalState {
  userGoals: UserGoals;
  hasLoaded: boolean;
  reportDownloaded: boolean;
  reportShared: boolean;
  reportFile: string;
  returnLink: string;
  dateGenerated: string;
  aiGoalsReport: AIGoalsReport;
  loadingGoalsReport: boolean;
  loadingUserGoals: boolean;
  loadingAiDeepInsight: boolean;
  statusConnect: boolean;
  /**
   * V-2. The last report-generation failure, or null.
   *
   * genAiGoalsReportFailure had no reducer handler at all, so a failure was
   * indistinguishable from nothing having happened.
   */
  aiGoalsReportError?: string | null;
  /**
   * L13. A refresh request is on its way to the server and has not answered.
   * The report's own status only changes once the server has queued it, so
   * without this a second press in that gap sent a second request.
   */
  refreshingAiGoalsReport?: boolean;
  aiDeepInsights?: AIDeepInsights;
}

export const initialGoalState: GoalState = {
  userGoals: null,
  hasLoaded: false,
  reportDownloaded: false,
  reportShared: false,
  reportFile: null,
  returnLink: null,
  dateGenerated: null,
  aiGoalsReport: null,
  loadingGoalsReport: false,
  loadingUserGoals: false,
  loadingAiDeepInsight: false,
  statusConnect: false,
  aiGoalsReportError: null,
  refreshingAiGoalsReport: false
};
